/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Col_CostInputs */

const en_mk_model_col_cost = /** @type {(inputs: Mk_Model_Col_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. cost`)
};

const id_mk_model_col_cost = /** @type {(inputs: Mk_Model_Col_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkiraan biaya`)
};

/**
* | output |
* | --- |
* | "Est. cost" |
*
* @param {Mk_Model_Col_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_col_cost = /** @type {((inputs?: Mk_Model_Col_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Col_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_col_cost(inputs)
	return en_mk_model_col_cost(inputs)
});